import { createContext, useContext, type ReactNode } from "react";
import { useSavedComponentsStore, type SavedComponentsApi } from "./useSavedComponents";

const SavedComponentsContext = createContext<SavedComponentsApi | null>(null);

/** Provides the localStorage-backed saved-components store to the chrome (the
 *  "My Dashboard" pill + sheet) and the surface (per-component save buttons). */
export function SavedComponentsProvider({
  clientId,
  children,
}: {
  clientId: string;
  children: ReactNode;
}) {
  const api = useSavedComponentsStore(clientId);
  return (
    <SavedComponentsContext.Provider value={api}>{children}</SavedComponentsContext.Provider>
  );
}

/** Returns the saved-components API, or null when no provider is mounted (e.g.
 *  isolated component tests) — callers render the save affordance only when
 *  this is non-null. */
export function useSavedComponentsOptional(): SavedComponentsApi | null {
  return useContext(SavedComponentsContext);
}

export function useSavedComponents(): SavedComponentsApi {
  const ctx = useContext(SavedComponentsContext);
  if (!ctx) {
    throw new Error("useSavedComponents must be used within <SavedComponentsProvider>");
  }
  return ctx;
}
